// Foydalanuvchi holati (users.status) va usta moderatsiyasi (users.moderation_status) yorliqlari.
// Qiymatlar manbasi: backend services/userBlock.js (status: 'active' | 'blocked') va
// services/providerModeration.js (approved / pending / rejected + eski sinonimlar).
// Noma'lum qiymatda xom matn qaytariladi (bo'sh qoldirilmaydi).

const norm = (v) => String(v == null ? '' : v).trim().toLowerCase();

const USER_STATUS = {
  active: 'Faol',
  inactive: 'Nofaol',
  blocked: 'Bloklangan',
  banned: 'Bloklangan',
};

const MODERATION = {
  approved: 'Tasdiqlangan',
  active: 'Tasdiqlangan',
  verified: 'Tasdiqlangan',
  accepted: 'Tasdiqlangan',
  tasdiqlangan: 'Tasdiqlangan',
  tasdiqlandi: 'Tasdiqlangan',
  pending: 'Kutilmoqda',
  moderatsiyada: 'Kutilmoqda',
  kutilmoqda: 'Kutilmoqda',
  rejected: 'Rad etilgan',
  declined: 'Rad etilgan',
  denied: 'Rad etilgan',
  'rad etilgan': 'Rad etilgan',
  'rad etildi': 'Rad etilgan',
};

export const userStatusLabel = (v) => USER_STATUS[norm(v)] || (v == null ? '' : String(v));
export const moderationStatusLabel = (v) => MODERATION[norm(v)] || (v == null ? '' : String(v));
